import { Button, ButtonSize, ButtonVariant, IconVariants, Modal, ModalSize, Text, TextVariants } from "@next-platform/client-common-spicy-ui";

import { LocalizedLink } from "@/components/LocalizedLink/LocalizedLink";
import { ROUTES } from "@/constants";
import { useTheme } from "@/hooks/useTheme";

export type UnlockCustomVoicesModalProps = {
  isOpen: boolean;
  onClose: (open: boolean) => void;
};

const UnlockCustomVoicesModal = (props: UnlockCustomVoicesModalProps) => {
  const { isOpen, onClose } = props;
  const { isDark } = useTheme();
  const textToSpeechGuideUrl = `https://docs.spicychat.ai/product-guides/premium-features/text-to-speech`;

  return (
    <Modal
      title="Unlock Custom Voices"
      className="dark:!bg-gray-6 gap-md"
      size={ModalSize.LARGE}
      open={isOpen}
      onOpenChange={onClose}
      loading={false}
    >
      <Text variant={TextVariants.LABEL_LARGE_REGULAR} className="text-gray-12">
        Clone your own voice or mix unique tones to create one-of-a-kind chatbot personalities. Stand out with emotion, speed, and style that sound
        truly yours.
      </Text>
      <LocalizedLink to={ROUTES.subscribe}>
        <Button
          onClick={() => onClose(false)}
          iconStart={IconVariants.CROWN}
          size={ButtonSize.LARGE}
          variant={ButtonVariant.TRANSPARENT}
          className="w-full gap-lg bg-gradient-to-r from-purple-9 to-blue-9 text-white"
        >
          Upgrade Now
        </Button>
      </LocalizedLink>
      <Text className="text-xs flex items-center">
        Find out more detail about Custom Voice
        <LocalizedLink to={textToSpeechGuideUrl} target="_blank">
          <img src={isDark ? "/Assets/spicychat.svg" : "/Assets/spicychat_192x192.png"} width={16} className="ml-3" />
        </LocalizedLink>
      </Text>
    </Modal>
  );
};

export default UnlockCustomVoicesModal;
